{
    "cancel": "Interrompre",
    "delete": "Supprimer",
    "error_occurred": "Une erreur s'est produite.",
    "field_error_any": "Veuillez renseigner au moins un de ces champs : ${1}",
    "field_error_email": "Veuillez saisir une adresse e-mail valide",
    "field_error_phone_invalid": "Veuillez saisir un numéro de téléphone valide",
    "field_error_phone_starts_with_zero": "Un code de pays existe déjà. Veuillez supprimer le \"0\" du numéro de téléphone.",
    "field_error_required": "Veuillez remplir ce champ",
    "field_is_required": "Champ obligatoire",
    "field_placeholder_address_search": "Saisissez une adresse",
    "link_sent": "Lien envoyé, veuillez vérifier",
    "network_error": "Erreur de réseau",
    "next": "Continuer",
    "ok": "OK",
    "open": "Ouvrir",
    "page_not_found_title": "Cette page n'a pas été trouvée",
    "save": "Sauvegarder",
    "state_refused": "Refusé"
}